import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { ElementType } from '../../types/element.types';

interface DraggableElementProps {
  type: ElementType;
  label: string;
  icon: string;
}

/**
 * Draggable Element Component
 * Individual element in the library that can be dragged to the canvas
 */
const DraggableElement: React.FC<DraggableElementProps> = ({ type, label, icon }) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `new-${type}`,
    data: {
      type: 'new-element',
      elementType: type,
      elementLabel: label,
    },
  });

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      className={`
        flex items-center gap-3 p-3 bg-white border-2 rounded-lg
        cursor-grab active:cursor-grabbing 
        transition-all duration-200 ease-out
        ${isDragging 
          ? 'opacity-30 scale-95 border-primary-500 shadow-lg' 
          : 'border-[#6F6F6F] hover:border-[#003C07] hover:shadow-md'
        }
      `}
    >
      <div className="text-2xl transition-transform duration-200">{icon}</div>
      <div className="flex-1">
        <div className="text-sm font-medium text-gray-900">{label}</div>
        <div className="text-xs text-gray-500">Drag to canvas</div>
      </div>
    </div>
  );
};

export default DraggableElement;

